import React, { useEffect, useState } from 'react'
import useAnimate from '../../hooks/useAnimate';
// import material ui
import { makeStyles, TextField, Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { Autocomplete } from '@material-ui/lab';
import { withStyles } from '@material-ui/styles';
// import i18n
import { useTranslation } from 'react-i18next';
// import components
import DashboardButtonBack from '../../_components/DashboardButtonBack';
import DashboardAnimate from '../../_components/DashboardAnimate';
import DashboardBanner from '../../_components/DashboardBanner';
// import mask
import InputElement from "react-input-mask";
// import redux
import { autocompleteActions } from '../../_actions/autocompleteManager.actions';
import { connect } from 'react-redux';
// import fetch
import axInst from '../../_helpers/axios-instance';

const useStyles = makeStyles(theme => ({
    container: {
        maxWidth: 1246,
        margin: "0 auto",
        padding: "0 15px"
    },

    body: {
        padding: "30px 0",
        [theme.breakpoints.down(768)]: {
            padding: "15px 0"
        },
    },

    card: {
        maxWidth: 808,
        width: "100%",
        margin: "0 auto",
        padding: "36px 64px 56px 64px",
        boxSizing: "border-box",
        [theme.breakpoints.down(768)]: {
            padding: "36px",
        },
        [theme.breakpoints.down(479)]: {
            padding: "20px",
        },
    },

    card__title: {
        display: "flex",
        alignItems: "center",
        gap: 5,
        fontSize: 16,
        fontWeight: 700,
        color: "#2F80ED",
        paddingBottom: 50,
    },

    form: {
        display: "grid",
        gap: 16,
    },

    wrapper: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: 20,
        [theme.breakpoints.down(768)]: {
            gridTemplateColumns: "repeat(1, 1fr)",
        },
    },

    input: {
        display: "flex",
        flexDirection: "column",
        gap: 4,
    },

    input_message: {
        color: "#279F51",
    },

    btn: {
        width: 164,
        margin: "16px auto 0 auto",
        fontWeight: 700,
    },
}));

const Input = withStyles({
    root: {
        border: "0.8px solid #8E95A9",
        height: "42px",
        borderRadius: "4px",

        '& .MuiInputBase-input': {
            width: "100%",
            border: 0,
            padding: "0 10px !important",
            boxSizing: "border-box",
        },

        '& .MuiFormLabel-root': {
            left: 15,
            color: '#000',

            '&.Mui-focused': {
                color: '#315EFB',
            },
            '&.MuiInputLabel-shrink': {
                color: '#315EFB',
            },
        },

        '& .MuiFilledInput-root': {
            background: 'transparent',
        },
        '& .MuiInput-underline:before': {
            border: 'none',
            content: '',
        },
        '& .MuiInput-underline:after': {
            border: 'none',
            content: '',
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 'none',
        },
    },
})(TextField);

const CreateManagerPage = (props) => {
    const {
        cities,
        positions,
        getCities,
        getPositions,
        userSelectedData,
    } = props;
    useAnimate();
    const classes = useStyles();
    const { t } = useTranslation();
    const [existsProfile, setExistsProfile] = useState(true);
    const [error, setError] = useState(false);
    const [snack, setSnack] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [email, setEmail] = useState("");
    const [formData, setFormData] = useState({
        user__first_name: "",
        user__last_name: "",
        phone: "",
        position: {},
        city: {},
    });

    const handleChange = (e, name) => {
        const value = e?.target?.value;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const onChange = (value, name) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    useEffect(() => {
        const regex = /^\+38 \(\d{3}\) \d{3}-\d{2}-\d{2}$/;
        const phoneIsValid = regex.test(formData.phone);
        const isValid =
            formData?.phone?.length !== 13 ||
            formData?.user__first_name?.length < 3 ||
            formData?.user__last_name?.length < 3 ||
            !formData?.city?.id ||
            !formData?.position?.id ||
            setError(isValid || !phoneIsValid);
    }, [formData]);

    const handleCloseAction = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnack(false);
    };

    const action = (
        <React.Fragment>
            <btn onClick={handleCloseAction}>UNDO</btn>
        </React.Fragment>
    );

    const onSubmitEmail = (e) => {
        setDisabled(true);
        e.preventDefault();
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(String(email).toLowerCase())) {
            setSnack(true);
            return;
        }

        axInst.post('/api/create-manager/check-if-exists-user', { email: email }).then(response => {
            if (response?.data?.first_name && response?.data?.last_name) {
                window.history.back();
            } else {
                setExistsProfile(false);
            }
        }).catch(err => {
            setSnack(true);
        }).finally(() => {
            setDisabled(false);
        });
    };

    const onSubmit = (e) => {
        setDisabled(true);
        e.preventDefault();
        if (error) {
            setSnack(true);
            return;
        }

        axInst.post(`api/create-manager/${userSelectedData?.customer_id}`, {
            user: {
                first_name: formData?.user__first_name,
                last_name: formData?.user__last_name,
                email: email,
            },
            phone: formData?.phone,
            position_id: formData?.position?.id,
            city_id: formData?.city?.id,
        }).then(response => {
            window.history.back();
        }).catch(err => {
            setSnack(true);
        }).finally(() => {
            setDisabled(false);
        });
    };

    return (
        <main className="dashboard">
            <DashboardBanner />
            <div className={classes.container}>
                <div className={classes.body}>
                    <div className={classes.back}><DashboardButtonBack /></div>
                    <h1 className="dashboard__title" style={{ padding: "25px 0" }}>{t("common:add_manager")}</h1>
                    <DashboardAnimate style={{ transform: "scale(1)" }}>
                        {existsProfile ? (
                            <div className={`dashboard-card ${classes.card}`}>
                                <h2 className={classes.card__title}><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.36969 23.1547C6.21453 23.1401 6.0684 23.0727 5.95622 22.963C5.87676 22.8835 5.81977 22.7843 5.79108 22.6756C5.76226 22.5663 5.76304 22.4514 5.79334 22.3426L5.79337 22.3426L5.79461 22.3379L6.93546 18.0829L6.9363 18.0797C7.08425 17.5128 7.37989 16.9953 7.79308 16.58C7.79324 16.5798 7.79341 16.5796 7.79357 16.5795L22.4959 1.8926C22.9152 1.49389 23.4718 1.27148 24.0506 1.27148C24.6298 1.27148 25.1867 1.49417 25.6062 1.89336L27.0495 3.32129C27.0499 3.32171 27.0503 3.32213 27.0508 3.32255C27.4603 3.73436 27.6902 4.29156 27.6902 4.8724C27.6902 5.45361 27.46 6.01115 27.05 6.42304C27.0498 6.42319 27.0497 6.42335 27.0495 6.4235L12.345 21.128C12.3447 21.1284 12.3443 21.1287 12.3439 21.1291C11.9243 21.5428 11.4068 21.8435 10.8397 22.0031L6.36969 23.1547ZM8.71978 21.7449L8.92393 21.949L9.20279 21.8743L10.6973 21.4737C10.6975 21.4737 10.6977 21.4736 10.6979 21.4735C11.1743 21.3467 11.6081 21.0948 11.9543 20.7438L12.5363 20.1771L12.8994 19.8236L12.5411 19.4653L9.47314 16.3974L9.12427 16.0485L8.77078 16.3927L8.18495 16.9631L8.18491 16.9631L8.18 16.968C7.83269 17.3157 7.58138 17.7474 7.45055 18.2212L7.45053 18.2212L7.44955 18.2248L7.04872 19.7202L6.97397 19.9991L7.17812 20.2032L8.71978 21.7449ZM12.9285 19.0778L13.2821 19.4314L13.6356 19.0778L24.0111 8.70241L24.3646 8.34885L24.0111 7.9953L20.9431 4.92738L20.5896 4.57383L20.236 4.92738L9.86062 15.3028L9.50707 15.6564L9.86062 16.0099L12.9285 19.0778ZM26.6627 6.05075L26.6648 6.04865C26.9723 5.73746 27.1448 5.3176 27.1448 4.8801C27.1448 4.44261 26.9723 4.02274 26.6648 3.71156L26.6646 3.71136L25.2309 2.26219L25.2297 2.26103C25.0761 2.1068 24.8936 1.98442 24.6925 1.90091C24.4915 1.81741 24.276 1.77442 24.0583 1.77442C23.8407 1.77442 23.6251 1.81741 23.4241 1.90091C23.2231 1.98442 23.0406 2.1068 22.887 2.26102L22.886 2.26205L21.3289 3.83455L20.9788 4.18809L21.3306 4.53991L24.3985 7.60782L24.7521 7.96138L25.1056 7.60782L26.6627 6.05075ZM27.524 27.7795H1.46984C1.39801 27.7795 1.32912 27.751 1.27833 27.7002C1.22754 27.6494 1.19901 27.5805 1.19901 27.5087C1.19901 27.4369 1.22754 27.368 1.27833 27.3172C1.32912 27.2664 1.39801 27.2379 1.46984 27.2379H27.524C27.5958 27.2379 27.6647 27.2664 27.7155 27.3172C27.7663 27.368 27.7948 27.4369 27.7948 27.5087C27.7948 27.5805 27.7663 27.6494 27.7155 27.7002C27.6647 27.751 27.5958 27.7795 27.524 27.7795Z" fill="#F5F7FB" stroke="#2F80ED" />
                                </svg> {t("common:personal_info")}</h2>
                                <form className={`dashboard-form ${classes.form}`} onSubmit={onSubmitEmail}>
                                    <div className={classes.input}>
                                        <label>{t("common:email_label")}</label>
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                    <button disabled={disabled} className={`btn ${classes.btn}`}>{t("common:create")}</button>
                                </form>
                            </div>
                        ) : (
                            <div className={`dashboard-card ${classes.card}`}>
                                <h2 className={classes.card__title}><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.36969 23.1547C6.21453 23.1401 6.0684 23.0727 5.95622 22.963C5.87676 22.8835 5.81977 22.7843 5.79108 22.6756C5.76226 22.5663 5.76304 22.4514 5.79334 22.3426L5.79337 22.3426L5.79461 22.3379L6.93546 18.0829L6.9363 18.0797C7.08425 17.5128 7.37989 16.9953 7.79308 16.58C7.79324 16.5798 7.79341 16.5796 7.79357 16.5795L22.4959 1.8926C22.9152 1.49389 23.4718 1.27148 24.0506 1.27148C24.6298 1.27148 25.1867 1.49417 25.6062 1.89336L27.0495 3.32129C27.0499 3.32171 27.0503 3.32213 27.0508 3.32255C27.4603 3.73436 27.6902 4.29156 27.6902 4.8724C27.6902 5.45361 27.46 6.01115 27.05 6.42304C27.0498 6.42319 27.0497 6.42335 27.0495 6.4235L12.345 21.128C12.3447 21.1284 12.3443 21.1287 12.3439 21.1291C11.9243 21.5428 11.4068 21.8435 10.8397 22.0031L6.36969 23.1547ZM8.71978 21.7449L8.92393 21.949L9.20279 21.8743L10.6973 21.4737C10.6975 21.4737 10.6977 21.4736 10.6979 21.4735C11.1743 21.3467 11.6081 21.0948 11.9543 20.7438L12.5363 20.1771L12.8994 19.8236L12.5411 19.4653L9.47314 16.3974L9.12427 16.0485L8.77078 16.3927L8.18495 16.9631L8.18491 16.9631L8.18 16.968C7.83269 17.3157 7.58138 17.7474 7.45055 18.2212L7.45053 18.2212L7.44955 18.2248L7.04872 19.7202L6.97397 19.9991L7.17812 20.2032L8.71978 21.7449ZM12.9285 19.0778L13.2821 19.4314L13.6356 19.0778L24.0111 8.70241L24.3646 8.34885L24.0111 7.9953L20.9431 4.92738L20.5896 4.57383L20.236 4.92738L9.86062 15.3028L9.50707 15.6564L9.86062 16.0099L12.9285 19.0778ZM26.6627 6.05075L26.6648 6.04865C26.9723 5.73746 27.1448 5.3176 27.1448 4.8801C27.1448 4.44261 26.9723 4.02274 26.6648 3.71156L26.6646 3.71136L25.2309 2.26219L25.2297 2.26103C25.0761 2.1068 24.8936 1.98442 24.6925 1.90091C24.4915 1.81741 24.276 1.77442 24.0583 1.77442C23.8407 1.77442 23.6251 1.81741 23.4241 1.90091C23.2231 1.98442 23.0406 2.1068 22.887 2.26102L22.886 2.26205L21.3289 3.83455L20.9788 4.18809L21.3306 4.53991L24.3985 7.60782L24.7521 7.96138L25.1056 7.60782L26.6627 6.05075ZM27.524 27.7795H1.46984C1.39801 27.7795 1.32912 27.751 1.27833 27.7002C1.22754 27.6494 1.19901 27.5805 1.19901 27.5087C1.19901 27.4369 1.22754 27.368 1.27833 27.3172C1.32912 27.2664 1.39801 27.2379 1.46984 27.2379H27.524C27.5958 27.2379 27.6647 27.2664 27.7155 27.3172C27.7663 27.368 27.7948 27.4369 27.7948 27.5087C27.7948 27.5805 27.7663 27.6494 27.7155 27.7002C27.6647 27.751 27.5958 27.7795 27.524 27.7795Z" fill="#F5F7FB" stroke="#2F80ED" />
                                </svg> {t("common:personal_info")}</h2>
                                <form className={`dashboard-form ${classes.form}`} onSubmit={onSubmit}>
                                    <div className={classes.wrapper}>
                                        <div className={classes.input}>
                                            <label>{t("common:name_label")}</label>
                                            <input
                                                type="text"
                                                value={formData?.user__first_name}
                                                onChange={(e) => handleChange(e, 'user__first_name')}
                                            />
                                        </div>
                                        <div className={classes.input}>
                                            <label>{t("common:Surname")}</label>
                                            <input
                                                type="text"
                                                value={formData?.user__last_name}
                                                onChange={(e) => handleChange(e, 'user__last_name')}
                                            />
                                        </div>
                                    </div>
                                    <div className={classes.wrapper}>
                                        <div className={classes.autocomplete}>
                                            <label>{t("common:position_label")}</label>
                                            <Autocomplete
                                                onChange={(e, data) => onChange(data, "position")}
                                                onOpen={() => getPositions()}
                                                value={formData?.position || null}
                                                loading={positions?.loading}
                                                getOptionLabel={(option) => option.position}
                                                options={positions?.data}
                                                renderInput={(params) => <Input {...params} />}
                                            />
                                        </div>
                                        <div className={classes.autocomplete}>
                                            <label>{t("common:city_label")}</label>
                                            <Autocomplete
                                                onChange={(e, data) => onChange(data, "city")}
                                                onOpen={() => getCities()}
                                                value={formData?.city || null}
                                                loading={cities?.loading}
                                                options={cities?.data}
                                                getOptionLabel={(option) => option.name}
                                                renderInput={(params) => <Input {...params} />}
                                            />
                                        </div>
                                    </div>
                                    <div className={classes.wrapper}>
                                        <div className={classes.input}>
                                            <label>{t("common:Phone")}</label>
                                            <InputElement
                                                mask="+38 (999) 999-99-99"
                                                value={formData?.phone}
                                                placeholder={t('common:enter_your_phone')}
                                                onChange={(e) => handleChange(e, "phone")}
                                            />
                                        </div>
                                        <div className={classes.input}>
                                            <label>{t("common:email_label")}</label>
                                            <input
                                                type="email"
                                                value={email}
                                                readonly
                                            />
                                        </div>
                                    </div>
                                    <button disabled={disabled} className={`btn ${classes.btn}`}>{t("common:save")}</button>
                                </form>
                            </div>
                        )}
                    </DashboardAnimate>
                </div>
            </div>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                open={snack}
                action={action}
                autoHideDuration={6000}
                onClose={handleCloseAction}
                message={t("common:error")}>
                <Alert severity="error" variant="filled">
                    {error ? t('common:error_empty_input_label') : t('common:DataNotSent')}
                </Alert>
            </Snackbar>
        </main >
    )
}

function mapState(state) {
    const cities = state.cities;
    const positions = state.positions;
    const { userSelectedData } = state;

    return { cities, positions, userSelectedData };
}

const actionCreators = {
    getCities: autocompleteActions.getCities,
    getPositions: autocompleteActions.getPositions,
};

export default connect(mapState, actionCreators)(CreateManagerPage);